import { render, staticRenderFns } from "./MainSidebarMenu.vue?vue&type=template&id=0a04483e&scoped=true"
import script from "./MainSidebarMenu.vue?vue&type=script&lang=js"
export * from "./MainSidebarMenu.vue?vue&type=script&lang=js"
import style0 from "./MainSidebarMenu.vue?vue&type=style&index=0&id=0a04483e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a04483e",
  null
  
)

export default component.exports